import { useEffect, useState } from "react";
import { clientCMS } from "../../sanity/clientCMS.js";
import { useParams } from "react-router-dom";
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FiCalendar } from "react-icons/fi";
import { LuUserRoundPen } from "react-icons/lu";
import "./OnePost.css";

export default function OnePost(props) {
  const [onePostData, setOnePostData] = useState(null);
  const [dataContainer, setDataContainer] = useState(LoadingContainer);
  const { slug } = useParams();
  const builder = imageUrlBuilder(clientCMS);

  function urlFor(source) {
    return builder.image(source);
  }

  useEffect(() => {
    clientCMS
      .fetch(
        `*[_type == "post" && slug.current == "${slug}"]{
        title,
        slug,
        body[]{
            ...,
            asset -> {
                     ...,
            "_key": _id
            }
        },
        mainImage{
            asset->{
            _id,
            url
            },
        },
        "name": author->name,
        publishedAt,
        "categories": categories[]->title
    }`,
      )
      .then((data) => setOnePostData(data))
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!onePostData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, [slug]);

  return (
    <Container>
      <Row>
        {onePostData && onePostData.length > 0
          ? onePostData &&
            onePostData.map((post, index) => (
              <Container key={index}>
                <Row className="one-post-row">
                  <Col md={4}>
                    <img
                      src={urlFor(post.mainImage.asset.url)
                        .width(280)
                        .quality(100)
                        .dpr(2)
                        .url()}
                      alt="imagem artigo"
                      className="one-post-img"
                    />
                  </Col>
                  <Col md={8} className="one-post-first-col">
                    <h2 style={{ color: props.titleColor }}>{post.title}</h2>
                    <Container className="one-post-categories">
                      <Row>
                        {post.categories.map((category, id) => (
                          <Col
                            xl={3}
                            lg={4}
                            md={6}
                            xs={12}
                            className="one-post-category-col"
                            key={id}
                            style={{ color: props.btnColor }}
                          >
                            <div className="one-post-category">{category}</div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                    <div className="one-post-info">
                      <div
                        style={{
                          color: props.textColor,
                          fontSize: props.textSize,
                        }}
                      >
                        <FiCalendar className="one-post-icon" />
                        {new Date(post.publishedAt).toLocaleDateString()}
                      </div>
                      <div
                        className="one-post-author"
                        style={{
                          color: props.textColor,
                          fontSize: props.textSize,
                        }}
                      >
                        <LuUserRoundPen className="one-post-icon" />
                        {post.name}
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="one-post-row">
                  <Col className="one-post-second-col">
                    <BlockContent
                      blocks={post.body}
                      projectId={clientCMS.projectId}
                      dataset={clientCMS.dataset}
                    />
                  </Col>
                </Row>
              </Container>
            ))
          : dataContainer}
      </Row>
    </Container>
  );
}
